// extracted by mini-css-extract-plugin
module.exports = {"digit":"RollingNumber_digit__EuLxY","roll-digit":"RollingNumber_roll-digit__MLpE2"};